// This file is automatically generated. Do not edit manually.

import { ObjectAttributeValueWithField } from "src/api/generated/erp/common/objectAttributes/model/objectAttributeValueWithField";
import { SalesLeadView } from "src/api/generated/erp/db/types/tables/salesLeadView";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace SingleSalesLeadViewApi {
	export async function getSingleSalesLeadViewData(args: {
		salesLeadId: number;
	}): Promise<SingleSalesLeadViewApi_Data> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/sales/crm/singleSalesLeadView/getSingleSalesLeadViewData",
			method: "POST",
			data: {
				salesLeadId: args.salesLeadId,
			},
		});
		return response as SingleSalesLeadViewApi_Data;
	}
}

export interface SingleSalesLeadViewApi_Data {
	attributes: Array<ObjectAttributeValueWithField>;
	lead: SalesLeadView;
}
